import { chain } from "lodash";
import { ValidationErrorLevels } from "../../../../../common/validation/ValidationErrorLevels";
import { ValidationScopes } from "../../../../../common/validation/ValidationScopes";
import { ValidationContext } from "../../../../../common/validation/validationContext";
import { ForkalkylsmallDTO } from "../../models/ForkalkylsmallDTO";

export class ForkalkylsmallValidation {
    static init(mall: ForkalkylsmallDTO, existingMallar: ForkalkylsmallDTO[]): ValidationContext {
        const context = new ValidationContext();
        // Fuling? Får inte till det annars.
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () => !(mall.namn === null || mall.namn === undefined || mall.namn.length === 0),
                message: { text: "Mallnamn får inte vara tomt" },
                model: () => mall.namn,
                name: "namnRequired"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () => mall.namn.length <= 40,
                message: { text: "Max 40 tecken för mallnamn" },
                model: () => mall.namn,
                name: "maxLengthError"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () => {
                    const allExceptCurrentOneIfItIsAlreadySaved = existingMallar.filter(m => m.id !== mall.id);
                    const nameTaken = allExceptCurrentOneIfItIsAlreadySaved.some(x => x.namn.trim().toLowerCase() === mall.namn.trim().toLowerCase());
                    // Namnet är upptaget men expression() kräver att "true" ska returneras om allt går bra, därför negeras boleska värdet... argh :)
                    return !nameTaken;
                },
                message: { text: "Namnet är upptaget" },
                model: () => mall.namn,
                name: "namnAlreadyTaken"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () => mall.handelssortiment.every(hs => hs.handelssortimentId > 0 || hs.handelssortimentsGruppId > 0),
                message: { text: "Handelssortimentsgrupp eller handelssortiment måste tilldelas" },
                model: () => mall.handelssortiment,
                name: "missingHandelssortiment"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                // Grupperar på hsid+hsgruppid och jämför så att antal grupper är lika med antalet rader
                expression: () => chain(mall.handelssortiment)
                    .groupBy(x => `${x.handelssortimentsGruppId ?? "0"}-${x.handelssortimentId ?? "0"}`)
                    .size()
                    .value() === mall.handelssortiment.length,
                message: { text: "Alla rader måste vara unika med handelssortiment och handelssortimentgrupper" },
                model: () => mall.handelssortiment,
                name: "uniqueRows"
            }

        ]);
        return context;
    }
}
